// extracted by mini-css-extract-plugin
export default {"eventsGraphicPromo":"EventsGraphicPromo_eventsGraphicPromo__ODQwZ"};